import { ErrorMessage, StyledInput, Wrapper } from './Input.parts';
import React from 'react';

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  value: string;
  name: string;
  placeholder?: string;
  id?: string;
  type?: string;
  errorText?: string;
};
export const Input = ({ onChange, onBlur, value, placeholder, id, type, name, errorText }: Props) => {
  return (
    <Wrapper>
      <StyledInput
        autoComplete="street-address"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        placeholder={placeholder}
        id={id}
        type={type}
        name={name}
      />
      <ErrorMessage>{errorText}</ErrorMessage>
    </Wrapper>
  );
};
